import { createFileRoute } from '@tanstack/react-router';
import { TopLevelPage } from '@/components/top-level-page';
import { validateBookingSearch } from '@/features/online-booking/nav-ids';
import { OnlineBookingPage } from '@/features/online-booking/pages/online-booking-page';

export const Route = createFileRoute('/_app/online-booking')({
  validateSearch: validateBookingSearch,
  component: BookingRoute,
});

function BookingRoute() {
  const { step } = Route.useSearch();
  return (
    <TopLevelPage path="/online-booking">
      <OnlineBookingPage step={step} />
    </TopLevelPage>
  );
}
